import { Check, AlertCircle, Info, X } from "lucide-react";
import { T } from "../tokens";
import { useToastStore, type ToastVariant } from "../store/toast";

const META: Record<ToastVariant, { color: string; bg: string; bdr: string; Icon: typeof Check }> = {
  success: { color: T.ok,   bg: T.okBg,   bdr: T.okBdr,   Icon: Check },
  error:   { color: T.err,  bg: T.errBg,  bdr: T.errBdr,  Icon: AlertCircle },
  info:    { color: T.info, bg: T.infoBg, bdr: T.infoBdr, Icon: Info },
};

/** Bottom-right toast stack. Mounted once, app-wide (App.tsx). */
export function Toaster() {
  const toasts  = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  if (toasts.length === 0) return null;

  return (
    <div
      role="status" aria-live="polite"
      style={{
        position: "fixed", zIndex: 9999, bottom: "20px", right: "20px",
        display: "flex", flexDirection: "column", gap: "10px",
        maxWidth: "min(360px, calc(100vw - 40px))", pointerEvents: "none",
      }}
    >
      {toasts.map((t) => {
        const { color, bg, bdr, Icon } = META[t.variant];
        return (
          <div key={t.id} style={{
            pointerEvents: "auto", display: "flex", alignItems: "center", gap: "10px",
            background: T.s1, border: `1px solid ${bdr}`, borderRadius: "10px",
            padding: "11px 12px 11px 13px", boxShadow: "0 8px 32px rgba(0,0,0,0.28)",
            animation: "toastIn 0.18s ease",
          }}>
            <span style={{
              display: "flex", flexShrink: 0, width: 22, height: 22, borderRadius: "50%",
              background: bg, color, alignItems: "center", justifyContent: "center",
            }}>
              <Icon size={13} strokeWidth={2.2}/>
            </span>
            <span style={{ flex: 1, fontFamily: T.body, fontSize: "13px", color: T.t0, lineHeight: 1.35 }}>
              {t.message}
            </span>
            <button
              type="button" onClick={() => dismiss(t.id)} aria-label="Dismiss"
              style={{ display: "flex", flexShrink: 0, background: "transparent", border: "none",
                color: T.t2, cursor: "pointer", padding: "2px" }}
            >
              <X size={14}/>
            </button>
          </div>
        );
      })}
    </div>
  );
}
